<template>
  <div class="m-dialog-mask">
    <div class="m-modal" :style="`width: ${width}px;`">
      <div class="m-modal-content">
        <svg
          class="u-close"
          viewBox="64 64 896 896"
          data-icon="close"
          aria-hidden="true"
          focusable="false"
          @click="onClose"
        >
          <path
            d="M563.8 512l262.5-312.9c4.4-5.2.7-13.1-6.1-13.1h-79.8c-4.7 0-9.2 2.1-12.3 5.7L511.6 449.8 295.1 191.7c-3-3.6-7.5-5.7-12.3-5.7H203c-6.8 0-10.5 7.9-6.1 13.1L459.4 512 196.9 824.9A7.95 7.95 0 0 0 203 838h79.8c4.7 0 9.2-2.1 12.3-5.7l216.5-258.1 216.5 258.1c3 3.6 7.5 5.7 12.3 5.7h79.8c6.8 0 10.5-7.9 6.1-13.1L563.8 512z"
          ></path>
        </svg>
        <div class="m-modal-header">
          <div class="u-head">{{ title }}</div>
        </div>
        <div class="m-modal-body">
          {{ content }}
        </div>
        <div class="mb-3">
          <Pagination :list="`${pagelist}`"></Pagination>
        </div>
        <div v-show="footer" class="m-modal-footer">
          <div class="d-flex justify-content-center mb-3">
            <ButtonMain button-name="検索" @click="onSearch"></ButtonMain>
            <div class="ms-4"></div>
            <ButtonMain button-name="選択" @click="onSelection"></ButtonMain>
            <div class="ms-4"></div>
            <ButtonMain button-name="解除" @click="onCancellation"></ButtonMain>
            <div class="ms-4"></div>
            <ButtonMain
              button-name="設定"
              @click="onConfiguration"
            ></ButtonMain>
            <div class="ms-4"></div>
            <ButtonMain button-name="キャンセル" @click="onCancel"></ButtonMain>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Dialog',
  props: {
    title: {
      type: String,
      default: '提示'
    },
    content: {
      type: String,
      default: ''
    },
    width: {
      type: Number,
      default: 640
    },
    pagelist: {
      type: Array,
      default: ''
    },

    footer: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    onClose() {
      this.$emit('close')
    },

    onSearch() {
      this.$emit('Search')
    },

    onSelection() {
      this.$emit('Selection')
    },

    onCancellation() {
      this.$emit('Cancellation')
    },

    onConfiguration() {
      this.$emit('Configuration')
    },

    onCancel() {
      this.$emit('Cancel')
    }
  }
}
</script>
<style lang="scss" scoped>
.m-dialog-mask {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10000;
  background: rgba(0, 0, 0, 0.45);
  .m-modal {
    position: relative;
    top: calc(50% - 240px);
    margin: 0 auto;
    .m-modal-content {
      position: relative;
      background: #fff;
      border-radius: 4px;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
      .u-close {
        width: 16px;
        height: 16px;
        position: absolute;
        top: 19px;
        right: 24px;
        fill: rgba(0, 0, 0, 0.45);
        font-size: 18px;
        line-height: 22px;
        cursor: pointer;
        transition: color 0.3s;
        &:hover {
          fill: rgba(0, 0, 0, 0.75);
        }
      }
      .m-modal-header {
        height: 22px;
        padding: 16px 24px;
        color: rgba(0, 0, 0, 0.65);
        border-radius: 4px 4px 0 0;
        border-bottom: 1px solid #e8e8e8;
        .u-head {
          margin: 0;
          color: rgba(0, 0, 0, 0.85);
          font-weight: 500;
          font-size: 16px;
          line-height: 22px;
          word-wrap: break-word;
        }
      }
      .m-modal-body {
        height: 324px;
        padding: 24px;
        font-size: 16px;
        line-height: 1.5;
        word-wrap: break-word;
        overflow: auto;
      }
      .m-modal-footer {
        padding: 10px 16px;
        text-align: right;
        .u-cancel {
          height: 32px;
          line-height: 32px;
          padding: 0 15px;
          font-size: 16px;
          border-radius: 4px;
          color: rgba(0, 0, 0, 0.65);
          background: #fff;
          border: 1px solid #d9d9d9;
          cursor: pointer;
          transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
          &:hover {
            color: #40a9ff;
            border-color: #40a9ff;
          }
          &:focus {
            color: #096dd9;
            border-color: #096dd9;
          }
        }
        .u-confirm {
          margin-left: 8px;
          height: 32px;
          line-height: 32px;
          padding: 0 15px;
          font-size: 16px;
          border-radius: 4px;
          background: #1890ff;
          border: 1px solid #1890ff;
          color: #fff;
          transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
          cursor: pointer;
          &:hover {
            color: #fff;
            background: #40a9ff;
            border-color: #40a9ff;
          }
          &:focus {
            background: #096dd9;
            border-color: #096dd9;
          }
        }
      }
    }
  }
}
</style>
